import { components } from '../../tokens/components/bluestone/GO';
import { createTheme } from '../../tokens/createTheme';
import type { DeprecatedTheme } from '../types';
import colorsGO from './colors/base/GO';
import alertTokens from './components/alert.tokens';
import createCalendarTokens from './components/calendar.tokens';
import checkboxTokens from './components/checkbox.tokens';
import drawerHeaderTokens from './components/drawerHeader.tokens';
import inputTokens from './components/input.tokens';
import pillTokens from './components/pill.tokens';
import sliderTokens from './components/slider.tokens';
import { ED } from './ED';

const uniqueBackground = '#66C431';
const colorsBrand = {
  0: '#F7FBEB', // brandPrimary.0 - primary.30
  1: '#A5CD38', // brandPrimary.1 - primary.50
  2: '#7CA82B', // brandPrimary.2 - primary.70
};
const brandSecondary = '#6CAE00';

const { colors: colorsED, borders, space, fontSizes, sizes, lineHeights } = ED;

const colors = {
  ...colorsED,
  ...colorsGO,
  brandPrimary: colorsBrand,
  promotional: {
    primary: {
      default: '#123300',
      dark: '#0B1F00',
    },
    secondary: {
      default: uniqueBackground,
      dark: '#215C00',
    },
  },
};
const { neutrals: colorsGrey } = colors;
const fontSizeBody = fontSizes.body;

const drawerHeader = drawerHeaderTokens({
  colorsBrand,
  colors,
  borders,
  space,
});
const slider = sliderTokens({
  colors,
  colorsBrand,
  sizes,
  space,
  fontSizeBody,
});
const checkbox = checkboxTokens({
  borders,
  colors,
  colorsBrand,
  space,
  lineHeights,
  fontSizeBody,
});
const input = inputTokens({
  fontSizes,
  lineHeights,
  colors,
});

const pill = pillTokens({ colors, colorsGrey });

const alert = alertTokens({ colors, borders });
const calendar = createCalendarTokens({ colors });

const GO: DeprecatedTheme = createTheme(
  'blueStone',
  {
    ...ED,
    colors: {
      ...colors,
      text: colors,
      brandSecondary,
      drawerHeader: drawerHeader.colors,
      slider: slider.colors,
      checkbox: checkbox.colors,
      brandedProgressBar: brandSecondary,
      decorationLine: {
        ...colors.decorationLine,
        default: brandSecondary,
      },
      input: input.colors,
      pill: pill.colors,
      alert: alert.colors,
      calendar: calendar.colors,
    },
    borders: {
      ...ED.borders,
      alert: alert.borders,
    },
  },
  components
);

export default GO;
